import {Component, EventEmitter, HostBinding, Input, Output} from '@angular/core';
import {IonChipBaseComponent} from 'app/core/ion-components/ionChip';

@Component({
  selector: 'app-chip',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
})
export class ChipComponent extends IonChipBaseComponent {

  @Input() id: string;
  @Input() removeButton: boolean = false;
  @Input() selected: boolean;
  @Input() selectedColor?: string;
  @Input() selectedBackground?: string;
  @Input() selectedTitle?: string;

  @Output() chipClicked: EventEmitter<any> = new EventEmitter();
  @Output() removeButtonClicked: EventEmitter<string> = new EventEmitter();

  @HostBinding('class')
  get classes() {
    return {
      [`chip-type-filter`]: this.removeButton,
      [`custom-color_${this.color}`]: this.color,
      [`selected`]: this.selected,
    };
  }

  onClickChip(event) {
    if (this.removeButton || this.disabled) {
      return;
    }

    const returnEvent =
      {
        detail: {value: this.id},   // такой формат для унификации доступа (ион элементы хранят значение в event.detail.value)
        pointerEvent: event
      };

    this.chipClicked.emit(returnEvent);
  }

  onClickRemoveButton(event) {
    event.stopPropagation();
    this.removeButtonClicked.emit(this.id);
  }
}
